import { c as _c } from "react/compiler-runtime";
import { type ComponentPropsWithoutRef, forwardRef, useContext } from 'react';
import { IndexContext, useCarouselContext } from './context';
import { useCarouselItem } from './useCarouselItem';
import { mergeProps } from './utils';
export interface CarouselItemProps extends ComponentPropsWithoutRef<'div'> {
  /** The placement of the item in the carousel */
  index?: number;
}
export const CarouselItem = forwardRef<HTMLDivElement, CarouselItemProps>(function CarouselItem(t0, forwardedRef) {
  const $ = _c(5);
  const {
    index,
    ...props
  } = t0;
  const ctx = useCarouselContext();
  const itemIndex = useContext(IndexContext);
  const t1 = index ?? itemIndex;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      index: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    itemProps
  } = useCarouselItem(t2, ctx.carouselState);
  const t3 = mergeProps(itemProps, props);
  let t4;
  if ($[2] !== forwardedRef || $[3] !== t3) {
    t4 = <div ref={forwardedRef} {...t3} />;
    $[2] = forwardedRef;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
});